import { Button, Spinner, Wordmark } from "@cntrl/ui";
import { APP_STORE_URL } from "../config/env.js";
import { reloadForUpdate, type OutdatedRemedy } from "./clientVersion.js";
import styles from "./ClientOutdatedScreen.module.scss";

/**
 * Shown in place of the whole app once the API refuses this client (`clientVersion.ts`). Nothing behind it can
 * work, so it is not dismissible. `updating`: the app is downloading the newest bundle and reloads into it on its
 * own. `store`: the app binary is too old and only an App Store update fixes it. `reload`: a web page already
 * reloaded once and is still behind — usually a deploy still rolling out — so the reader is asked, not looped.
 */
export function ClientOutdatedScreen({ remedy }: { remedy: OutdatedRemedy }) {
  if (remedy === "updating") {
    return (
      <main className={styles.screen} aria-labelledby="client-outdated-title">
        <div className={styles.brand}>
          <Wordmark size={28} />
        </div>
        <h1 id="client-outdated-title" className={styles.title}>
          Updating Artist CNTRL
        </h1>
        <Spinner size={20} label="Downloading the update" />
      </main>
    );
  }

  const store = remedy === "store";

  return (
    <main className={styles.screen} aria-labelledby="client-outdated-title">
      <div className={styles.brand}>
        <Wordmark size={28} />
      </div>
      <h1 id="client-outdated-title" className={styles.title}>
        {store ? "Update required" : "A new version is available"}
      </h1>
      <p className={styles.body}>
        {store
          ? "This version of Artist CNTRL is out of date. Update it from the App Store to keep going."
          : "Reload the page to keep going."}
      </p>
      {store ? (
        APP_STORE_URL ? (
          <Button onClick={() => window.location.assign(APP_STORE_URL)}>Open the App Store</Button>
        ) : null
      ) : (
        <Button onClick={reloadForUpdate}>Reload</Button>
      )}
    </main>
  );
}
